<mat-card class="card-style px-6 py-6 pt-0">
  <mat-card-header class="flex justify-between items-center">
    <mat-card-title class="">Itinerários da solicitação</mat-card-title>
    <button class="btn-icon" (click)="close()">
      <mat-icon>close</mat-icon>
    </button>
  </mat-card-header>

  <div class="mt-6">
    <mat-card class="card-style px-4 py-6">
      <div class="flex justify-between gap-2 mt-4">
        <div class="w-2/12"><strong>Tg:</strong> {{ item.codigoTg }}</div>
        <div class="w-10/12">
          <strong>Evento:</strong>
          {{ item.nomeEvento }}
        </div>
      </div>
      <div class="mt-4">
        <mat-divider></mat-divider>
      </div>
      <div class="flex justify-between gap-2 mt-4">
        <div class="w-10/12">
          <strong
            >{{
              item.nomeSubCliente && item.nomeSubCliente != ''
                ? 'Subcliente'
                : 'Cliente'
            }}:</strong
          >
          {{
            item.nomeSubCliente && item.nomeSubCliente != ''
              ? item.nomeSubCliente
              : item.nomeCliente
          }}
        </div>
        <div class="w-2/12">
          <strong>Início:</strong> {{ item.dataInicio }}<br />
          <strong>Fim:</strong> {{ item.dataFinal }}
        </div>
      </div>
      <div class="mt-4">
        <mat-divider></mat-divider>
      </div>
      <div class="flex justify-between gap-2 mt-4">
        <div class="w-3/12">
          <strong>Origem:</strong><br />
          Cidade: {{ item.cidadeOrigem }}<br />
          Estado: {{ item.estadoOrigem }}
        </div>
        <div class="w-3/12">
          <strong>Destino:</strong><br />
          Cidade: {{ item.cidadeDestino }}<br />
          Estado: {{ item.estadoDestino }}
        </div>
        <div class="w-3/12">
          <strong>Tipo Serviço:</strong> {{ item.descricaoTipoServico }}<br />
          <strong>Serviço:</strong> {{ item.descricaoServico }}
        </div>
        <div class="3/12">
          <strong>Tipo Veículo:</strong> {{ item.descricaoTipoVeiculo }}<br />
          <strong>Tipo Motorista</strong> {{ item.descricaoTipoMotorista }}
        </div>
      </div>
    </mat-card>
    <mat-card class="card-style px-4 py-2 mt-4">
      <div class="flex justify-between items-center gap-4 mt-4">
        <div class="w-full">
          <b>Observação:</b><br />
          <div class="text-base font-semibold text-red-800">
            {{ item.observacao ?? '' }}
          </div>
        </div>
      </div>
    </mat-card>
    @if (!loading) {
      <div class="flex flex-col gap-4 mt-4">
        @for (item of listItineraries; track item) {
          <mat-card class="card-style px-4 pb-6">
            <!--            <h4 class="mb-3">-->
            <!--              {{ item.trecho == 'O' ? 'Origem' : 'Destino' }}-->
            <!--            </h4>-->
            <h4 class="mb-1">
              {{
                item.trecho == 'O'
                  ? 'Origem'
                  : item.trecho == 'D'
                    ? 'Destino'
                    : 'Parada'
              }}
            </h4>
            @if (
              item.localParada != 'Origem' && item.localParada != 'Destino'
            ) {
              <div class="flex justify-between gap-2 mt-4">
                <div class="w-full">
                  <strong>Descrição:</strong> {{ item.localParada ?? '-' }}
                </div>
              </div>
            }
            <div class="flex justify-between gap-2 mt-4">
              <div class="w-2/12"><strong>Cep:</strong> {{ item.cep }}</div>
              <div class="w-8/12">
                <strong>Logradouro:</strong> {{ item.logradouro }}
              </div>
              <div class="w-2/12">
                <strong>Numero:</strong> {{ item.numero }}
              </div>
            </div>
            <div class="flex justify-between gap-2 mt-4">
              <div class="w-6/12">
                <strong>Complemento:</strong> {{ item.complemento }}
              </div>
              <div class="w-3/12">
                <strong>Latitude:</strong> {{ item.latitude }}
              </div>
              <div class="w-3/12">
                <strong>Longitude:</strong> {{ item.longitude }}
              </div>
            </div>
            <div class="flex justify-between gap-2 mt-4">
              <div class="w-7/12">
                <strong>Bairro:</strong> {{ item.bairro }}
              </div>
              <div class="w-3/12">
                <strong>Cidade:</strong> {{ item.cidade }}
              </div>
              <div class="w-2/12">
                <strong>Estado:</strong> {{ item.estado }}
              </div>
            </div>
            <div class="flex justify-between gap-2 mt-4">
              <div class="w-6/12">
                <strong>Hora da Parada:</strong> {{ item.horaParada }}
              </div>
              <div class="w-6/12">
                <strong>Tempo de Permanência:</strong> {{ item.tempoPermanencia }}
              </div>
            </div>
            <div class="flex justify-between gap-2 mt-4">
              <div class="w-full">
                <strong>Atividades:</strong> {{ item.atividades }}
              </div>
            </div>
          </mat-card>
        } @empty {}
      </div>
    } @else {
      <div class="mt-4">
        <mat-progress-bar mode="indeterminate"></mat-progress-bar>
      </div>
    }
  </div>
</mat-card>
